import { Dialog, DialogTitle } from '@mui/material';
import PageHeader from 'lib/designSystem/PageHeader';
import { ToggleTab } from 'lib/designSystem/PageHeader/types';
import { validateCompanyTypes } from 'lib/functions/utils';
import React from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'services/redux/store';

import ExternalEvaluation from './Components/ExternalEvaluation';
import InternalEvaluation from './Components/InternalEvaluation';

export type TType = 'creditLine';

export type Props = {
  type: TType;
  open: boolean;
  setOpen: (open: boolean) => void;
  onSuccess?: () => Promise<void>;
};

const NewEvaluation: React.FC<Props> = ({ type, open, setOpen, onSuccess }) => {
  const [toggleValue, setToggleValue] = useState('internal');
  const user = useSelector((state: RootState) => state.auth.user);
  const isFund = validateCompanyTypes(user, 'Fund');

  const tabs: ToggleTab[] = [
    { id: 'internal', label: 'Fuente Interna', value: 'internal' },
    { id: 'external', label: 'Fuente Externa', value: 'external' },
  ];

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>
        {isFund ? (
          <PageHeader.WithTitleAndActions
            iconType="insights"
            title="Nueva evaluación"
            subtitle="A continuación selecciona los parámetros para comenzar la
                evaluación automática."
            toggleTabs={tabs}
            toggleValue={toggleValue}
            onToggleChange={setToggleValue}
          />
        ) : (
          <PageHeader.TitleOnly
            iconType="insights"
            title="Nueva evaluación"
            subtitle="A continuación selecciona los parámetros para comenzar la
                evaluación automática."
          />
        )}
      </DialogTitle>
      {toggleValue === 'internal' && (
        <InternalEvaluation
          type={type}
          setOpen={setOpen}
          onSuccess={onSuccess}
        />
      )}
      {toggleValue === 'external' && (
        <ExternalEvaluation
          type={type}
          setOpen={setOpen}
          onSuccess={onSuccess}
        />
      )}
    </Dialog>
  );
};

export default NewEvaluation;
